import React from 'react';
import { StyleSheet } from 'react-native';
import { SettingsItem } from 'design-system/SettingsItem';
import { IconEdit, rem } from 'design-system';
import Modal from 'utils/packages/Modal';
import { IconCategory } from 'design-system/icons/IconCategory';
import useColors from 'hooks/useColors';
import { navigationRef } from 'utils/navigationv6';
import { isWeb } from '../../../constants';
const ManageCategoriesModalContent = () => {
    const colors = useColors();
    return (<>
      <SettingsItem icon={<IconEdit colorKey="brand"/>} title="Manage custom categories" onPress={() => {
            Modal.hide(() => navigationRef.navigateDeprecated('ManageCategories', {
                skipRefresh: true,
            }));
        }}/>
      <SettingsItem icon={<IconCategory alt color={colors.categories.custom}/>} title="Reorder categories" onPress={() => {
            Modal.hide(() => navigationRef.navigateDeprecated('ReorderCategories'));
        }}/>
    </>);
};
export const ManageCategoriesModal = {
    show: () => {
        Modal.show(<ManageCategoriesModalContent />, {
            containerStyle: styles.modal,
            title: 'Manage categories',
            textStyle: styles.textStyle,
        });
    },
    hide: Modal.hide,
};
const styles = StyleSheet.create({
    modal: {
        ...(!isWeb && {
            paddingHorizontal: 0,
        }),
    },
    textStyle: {
        marginBottom: rem(8),
    },
});
